import http from '@/utils/http'
const AccumActType = 102
export default {
  collectReward: (params) => {
    return http({
      url: '/json/activity/collectReward',
      method: 'post',
      data: { ...params, activityType: AccumActType }
    })
  },
  oneKeyCollect: (params) => {
    return http({
      url: '/json/activity/oneKeyCollect',
      method: 'post',
      data: { ...params, activityType: AccumActType }
    })
  },
  getRewardRecordList: (params) => {
    return http({
      url: '/json/activity/rewardRecordList',
      method: 'post',
      data: { ...params, activityType: AccumActType }
    })
  },
  getRewardList: (params) => {
    return http({
      url: '/json/activity/rewardList',
      method: 'post',
      data: { ...params, activityType: AccumActType }
    })
  },
}


